export const FULLFILL_AVAILABLE_SYSTEM_IDS = 'FULLFILL_AVAILABLE_SYSTEM_IDS'
export const FULLFILL_CURRENT_SYSTEM_ID = 'FULLFILL_CURRENT_SYSTEM_ID'
export const FULLFILL_CASES = 'FULLFILL_CASES'
export const FULLFILL_EDITED_CASE = 'FULLFILL_EDITED_CASE'
export const FULLFILL_REPORT_SAMPLE_TEMPLATES = 'FULLFILL_REPORT_SAMPLE_TEMPLATES'
export const RESET_PAGE = 'RESET_PAGE'
export const CHANGE_FILTER_VALUE = 'CHANGE_FILTER_VALUE'
export const CREATE_REPORT_IN_EDITED_CASE = 'CREATE_REPORT_IN_EDITED_CASE'
export const UPDATE_REPORT_IN_EDITED_CASE = 'UPDATE_REPORT_IN_EDITED_CASE'
export const FULLFILL_REPORTS_IN_EDITED_CASE = 'FULLFILL_REPORTS_IN_EDITED_CASE'
export const DELETE_REPORT = 'DELETE_REPORT'
export const ADD_AVAILABLE_SYSTEM_ID = 'ADD_AVAILABLE_SYSTEM_ID'
export const REMOVE_AVAILABLE_SYSTEM_ID = 'REMOVE_AVAILABLE_SYSTEM_ID'
export const FULFILL_CASE_DRAFTS = 'FULFILL_CASE_DRAFTS'
export const CHANGE_PROGRESS = 'CHANGE_PROGRESS'
export const SET_VALIDATION_ERRORS = 'SET_VALIDATION_ERRORS'
export const RESET_VALIDATION_ERRORS_BY_FIELD = 'RESET_VALIDATION_ERRORS_BY_FIELD'
export const UPDATE_SUITABLE_BATCH = 'UPDATE_SUITABLE_BATCH'
export const ADD_SPECIALIST_TO_REPORT = 'ADD_SPECIALIST_TO_REPORT'
export const DELETE_SPECIALIST_FROM_REPORT = 'DELETE_SPECIALIST_FROM_REPORT'
export const UPDATE_REPORT_SIGNATURE = 'UPDATE_REPORT_SIGNATURE'
export const CHANGE_REPORT_VALIDATED = 'CHANGE_REPORT_VALIDATED'
export const CHANGE_PAGINATION = 'CHANGE_PAGINATION'
export const UPDATE_REPORT_FILES = 'UPDATE_REPORT_FILES'
export const UPDATE_SAMPLE_IN_CASE_AFTER_RESET_DUE_DAYS = 'UPDATE_SAMPLE_IN_CASE_AFTER_RESET_DUE_DAYS'
export const SET_PATIENT_CONTEXT = 'SET_PATIENT_CONTEXT'


